import { BaseWebComponentRepository } from '../../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorRealTimePanelDataProviderFactory } from '../factory/IntegrityMonitorRealTimePanelDataProviderFactory';
import { IntegrityMonitorRealTimePanelBaseDataProvider } from '../dataProvider/IntegrityMonitorRealTimePanelBaseDataProvider';
import { IntegrityMonitorRealTimePanelWebComponentSchema } from '../types';

export class IntegrityMonitorRealTimePanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorRealTimePanelDataProviderFactory;
  public dataProvider: IntegrityMonitorRealTimePanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorRealTimePanelDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<IntegrityMonitorRealTimePanelWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
